<ejs-sidebar id="default-sidebar" #sidebar (created)="onCreated($event)" style="visibility: hidden"
  [showBackdrop]="true" [closeOnDocumentClick]="true">
  <div style='height: 100px'>
  </div>
  <app-panel-filtros *ngIf="Filtros" (evCambioFiltro)="FiltrosOnChange($event)" [SYS33CON]="SYS33CON"
    [arrFiltros]=Filtros>
  </app-panel-filtros>

</ejs-sidebar>

<div class="container-fluid">
  <div class="row mb-1">
    <div class="col-12">
      <h4 class="mt-4 letra-azul">
        {{SYS33DES}}
      </h4>
      <!-- mospina 10-10-16 EPT-2380 Cambio general identidad AVATAR -->
      <hr class="mt-1" style="border-top: 6px solid var(--app-oscuro, #0c7cb3);">
    </div>
  </div>

  <div class="row mb-4">
    <div class="col-md-2 col-xs-6">
      <button type="button" title="Filtrar" class="btn btn-info btn-label waves-light mb-4" (click)="toggleClick()">
        <i class="fas fa-filter label-icon" style="pointer-events: none;"></i> Filtrar
      </button>
    </div>
  </div>

  <div class="row mb-3" *ngIf="PanelesS38.length > 0">
    <div class="col-12">
      <div class="card">
        <div class="card-header text-dark bg-light">
          <h4 class="card-title">Paneles</h4>
        </div>
        <div class="card-body">
          <ng-container *ngFor="let panel of PanelesS38">
            <app-slider *ngIf="panel.SYS38TIP=='1'" [SYS33CON]="SYS33CON" [arrSLIDES]="panel.SLIDES">
            </app-slider>

            <app-perfil-personal *ngIf="panel.SYS38TIP=='2'" [SYS33CON]="SYS33CON"
              [InfoPersonal]="panel.InfoPersonal">
            </app-perfil-personal>

            <app-panel-eventos *ngIf="panel.SYS38TIP=='3'" [SYS33CON]="SYS33CON"
              [eventos]="panel.Eventos">
            </app-panel-eventos>

            <app-panel-acciones *ngIf="panel.SYS38TIP=='4'" [SYS33CON]="SYS33CON"
              [iconos]="panel.ICONOS">
            </app-panel-acciones>

            <app-panel-indicadores *ngIf="panel.SYS38TIP=='5'" [SYS33CON]="SYS33CON" [SYS38COD]="panel.SYS38COD"
              [arrFiltros]="arrFiltros">
            </app-panel-indicadores>

            <app-panel-listado *ngIf="panel.SYS38TIP=='6'" [SYS33CON]="SYS33CON" [SYS38COD]="panel.SYS38COD"
              [arrFiltros]="arrFiltros">
            </app-panel-listado>

            <app-panel-tablas *ngIf="panel.SYS38TIP=='7'" [SYS33CON]="SYS33CON" [SYS38COD]="panel.SYS38COD"
              [arrFiltros]="arrFiltros">
            </app-panel-tablas>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <div class="card">
        <div class="card-header text-dark bg-light">
          <h4 class="card-title">Reportes</h4>
        </div>
        <div class="card-body">
          <ng-container *ngIf="Reportes">
            <app-panel-reportes [Reportes]="Reportes" [arrFiltros]="arrFiltros">
            </app-panel-reportes>
          </ng-container>
        </div>
      </div>
    </div>
  </div>

  <div class="row mb-3">
    <div class="col-12">
      <div class="card">
        <div class="card-header text-dark bg-light">
          <h4 class="card-title">Gráficos</h4>
        </div>
        <div class="card-body">
          <div class="row">
            <div class="col-6" *ngFor="let grafico of Graficos">
              <app-echart [strSYS35COD]="grafico.SYS35COD" [strSYS35URL]="grafico.SYS35URL" [SYS33CON]="SYS33CON"
                [blnRefresh]="blnRefresh" [arrFiltros]="arrFiltros"></app-echart>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

</div>